import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
// import unsubscribe from 'assets/icons/unsubscribe.svg';
import { styleSizes } from "constants/styleSizes";

export const UnsubscribeScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: ${colors.almostBlack};
  .innerContainerTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    justify-content: flex-end;
    width: 100%;
    max-width: 1229px;
    box-sizing: border-box;
    padding: 0px 31px;
    height: 414px;
    align-items: flex-end;
    @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
      height: 300px;
    }
    @media (max-width: 798px) {
      height: 200px;
    }
  }

  .innerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .titleContainer {
    color: ${colors.almostBlack};
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.unsubscribeBackground};
    width: 100%;
    height: 414px;
    padding: 0 15px;
    @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
      height: 300px;
    }
    @media (max-width: 798px) {
      height: 200px;
    }
    .titleText {
      color: ${colors.almostBlack};
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
      @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
        transform: translateY(-120%);
      }
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        top: 130px;
      }
      .title {
        font-size: 48px;
        font-weight: bold;
        line-height: 72px;
        text-align: left;
        color: ${colors.white};
        white-space: nowrap;
        overflow: visible;
        @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
          font-size: 32px;
          line-height: 52px;
        }
        @media (max-width: 798px) {
          font-size: 24px;
          line-height: 32px;
        }
        .highLight {
          font-size: 66px;
          font-style: italic;
          white-space: nowrap;
          overflow: visible;
          @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
            font-size: 48px;
          }
          @media (max-width: 726px) {
            font-size: 24px;
            line-height: 32px;
          }
        }
      }
    }

    .unsubscribeImage {
      flex: 1;
      max-width: 573px;
      margin: 53px 0 0 0;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      width: 100%;
      z-index: 1;
      @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
        max-width: 391px;
      }
      @media (max-width: 798px) {
        max-width: 205px;
      }
      .unsubscribeImageImg {
        @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
          max-width: 391px;
        }
        @media (max-width: 726px) {
          max-width: 205px;
        }
      }
      .resubscribeImageImg {
        max-width: 526px;
        @media (max-width: ${styleSizes.wideScreenBreakpoint}) {
          max-width: 391px;
        }
        @media (max-width: 798px) {
          max-width: 205px;
        }
      }
    }
  }

  .titleContainerResubscribed {
    background-color: ${colors.optionBackground};
  }

  .missed {
    display: none;
    @media (max-width: ${styleSizes.mobileBreakpoint}) {
      display: block;
      }
  }

  .inputRow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 15px;

    .innerContainer {
      display: flex;
      flex-direction: column;
      width: 742px;
      min-width: 270px;
      padding: 44px 0;
      
      @media (max-width: ${styleSizes.tabletBreakpoint}) {
        padding: 32px 0;
      }

      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        padding: 16px 0;
      }
      .titleText {
        font-size: 24px;
        font-weight: bold;
        color: ${colors.almostBlack};
        margin-bottom: 32px;
        overflow: visible;
      }

      .description {
        font-size: 16px;
        color: ${colors.almostBlack};
        margin-bottom: 14px;

        a {
          text-decoration: underline;
        }
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
        width: 100%;
        text-align: left;
        margin-bottom: 24px;
      }
      }

      .otherField {
        width: 270px;
      }
      .checkboxes {
        //width: 40%;
        height: 100%;

        .checkbox {
          margin-bottom: 16px;
          text-align: left;
          margin-bottom: 12px;
        }
      }

      .buttonContainer {
        width: auto;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  /* @media only screen and (max-width: 1200px) {

    .innerContainer {
      flex-direction: column-reverse;
      padding: 0;
      margin: 0;
    }

    .titleContainer {
      height: auto;

      .titleText {
        margin: 20px 0;

        .title {
          text-align: center;
          font-size: 36px;
        }
      }

      .unsubscribeImage {
        max-width: 270px;
        min-width: 270px;
        height: 183px;
        margin-top: 20px;
      }
    }
  } */
`;